import { Calendar } from 'lucide-react';

import { cn } from '~/utils/cn';
import { formatDateShort } from '~/utils/date';

interface DateChipProps {
  /** ISO date string (rendered via `formatDateShort`). */
  iso: string;
  className?: string;
  /** `data-testid` for the chip (default `date-chip`). */
  testId?: string;
}

/** Calendar-icon + short-date pill. Uses the bespoke date-pill token triplet
 *  (`--surface-date-pill`, `--text-date-pill`, `--icon-date-pill`). */
export function DateChip({ iso, className, testId = 'date-chip' }: DateChipProps) {
  return (
    <span
      data-testid={testId}
      className={cn(
        'bg-surface-date-pill text-text-date-pill inline-flex h-8 items-center gap-2 rounded-lg px-4 py-1.5 text-sm font-medium',
        className,
      )}
    >
      <Calendar className="text-icon-date-pill h-3.5 w-3.5" aria-hidden="true" />
      {formatDateShort(iso)}
    </span>
  );
}
